module.exports = "/images/manila-standard.png?21347b01573b5f5079bb4d5075c0d2ae";